import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1694.11765,0 C1818.69176,0 1920,101.308235 1920,225.882353 L1920,1694.11765 C1920,1818.69176 1818.69176,1920 1694.11765,1920 L225.882353,1920 C101.308235,1920 0,1818.69176 0,1694.11765 L0,225.882353 C0,101.308235 101.308235,0 225.882353,0 L1694.11765,0 Z M790.588235,564.705882 L1129.41176,564.705882 L1129.41176,225.882353 L790.588235,225.882353 L790.588235,564.705882 Z M225.882353,564.705882 L564.705882,564.705882 L564.705882,225.882353 L225.882353,225.882353 L225.882353,564.705882 Z M225.882353,1129.41176 L564.705882,1129.41176 L564.705882,790.588235 L225.882353,790.588235 L225.882353,1129.41176 Z M225.882353,1694.11765 L564.705882,1694.11765 L564.705882,1355.29412 L225.882353,1355.29412 L225.882353,1694.11765 Z M790.230588,1694.58824 L1694.23059,1694.58824 L1694.23059,790.588235 L790.230588,790.588235 L790.230588,1694.58824 Z M1355.29412,564.705882 L1694.11765,564.705882 L1694.11765,225.882353 L1355.29412,225.882353 L1355.29412,564.705882 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconTableMergeCellsSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconTableMergeCellsSolid, _Component);

  var _super = _createSuper(IconTableMergeCellsSolid);

  function IconTableMergeCellsSolid() {
    _classCallCheck(this, IconTableMergeCellsSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconTableMergeCellsSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconTableMergeCells",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconTableMergeCellsSolid.displayName = "IconTableMergeCellsSolid";
  return IconTableMergeCellsSolid;
}(Component);

IconTableMergeCellsSolid.glyphName = 'table-merge-cells';
IconTableMergeCellsSolid.variant = 'Solid';
IconTableMergeCellsSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconTableMergeCellsSolid;
export { IconTableMergeCellsSolid };